// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import { connect } from 'react-redux';

// eslint-disable-next-line
import * as MuiCore from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import OutlinedPopover from '../ui/OutlinedPopover';


import * as AccountIcons from '../account/Icons';
import * as accountSelectors from "./selectors";
import * as Formatters from "../ui/Formatters";


const styles = theme => ({
  loadingProgress : {
  },
  loadingLabel : {
    ...theme.typography.body2,
    fontWeight: 'bold',
    marginLeft: 20,
  },
  invoiceTable : {
    borderCollapse: 'collapse',
    '& th' : {
      padding: '3px 20px',
      textAlign: 'left',
    },
    '& td' : {
      padding: '3px 20px',
    },
  },
  money : {
    textAlign: 'right',
  },
  summaryLine : {
    textAlign: 'right',
    fontWeight: 'bold',
  },
  totalLine : {
    borderTop : '1px solid ' + theme.brandingColors.poshBlack,
    borderBottom : '1px solid ' + theme.brandingColors.poshBlack,
  }
});

/*
 * Issue a payment on the selected invoice using a stored payment method
 */

class ConfirmSurcharge extends Component {

  state = {
  }

  render() {
    // eslint-disable-next-line
    const { classes,  popupLabel, onSubmit, onClose, open, account, invoice, surchargeObject, buttonText} = this.props;

    return(
      <React.Fragment>
        <OutlinedPopover open={open && (surchargeObject?.surchargeText ?? null) !== null}
                         icon={<AccountIcons.InvoiceIcon color='primary' fontSize='large'/>}
                         title={popupLabel}
                         maxWidth='md'
                         onClose={onClose}>
          <MuiCore.Grid container direction='column' spacing={1}>

            <MuiCore.Grid item>
              <table>
                <tbody>
                <tr>
                  <td style={{verticalAlign: 'top'}}>Account:</td>
                  <td><b>{account?.accountNumber} {account?.accountName}</b></td>
                </tr>
                <tr>
                  <td>Amount:</td>
                  <td><b>${surchargeObject?.amount}</b></td>
                </tr>
                <tr>
                  <td>Payment Type:</td>
                  <td><b>{surchargeObject?.methodType}</b></td>
                </tr>
                <tr>
                  <td>Surcharge:</td>
                  <td>
                    <b>{`${Formatters.formatMoney(surchargeObject?.surchargeAmount, invoice.currencyCode)}`}</b>
                  </td>
                </tr>
                <tr>
                  <td style={{whiteSpace: 'pre-wrap'}} colSpan="2">
                    <b>{surchargeObject?.surchargeText}</b></td>
                </tr>
                </tbody>
              </table>
            </MuiCore.Grid>

            <MuiCore.Grid item style={{marginTop: 20}}>
              <MuiCore.Button onClick={onSubmit}>
                {buttonText}
              </MuiCore.Button>
            </MuiCore.Grid>

          </MuiCore.Grid>
        </OutlinedPopover>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return ({
    surchargeObject : accountSelectors.getSurchargeObject(state),
    account : accountSelectors.getAccount(state),
    invoice : accountSelectors.getInvoice(state),
  });
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ConfirmSurcharge));
